export function interpolate(
  pattern,
  variables,
  maxLength = 25,
  preInterpolate = null,
) {
  const replacements = buildReplacements(pattern, variables);
  return interpolateInner(
    sanitize(pattern, /[^\p{N}\p{L}.,_}{ -]+/gu),
    sanitize(replacements, preInterpolate),
    maxLength,
  );
}

export function sanitize(value, sanitizer = /[^\p{N}\p{L}.,_ -]+/gu) {
  if (!value || (typeof value !== 'string' && typeof sanitizer !== 'function'))
    return value;

  return typeof sanitizer === 'function'
    ? sanitizer(value)
    : value.replace(sanitizer, '');
}

function buildReplacements(pattern, variables) {
  const tokens = pattern.match(/\{[\w\s]+\}/g);
  if (!tokens) return {};

  const normalize = (key) => key.replaceAll(/[\W\s]/g, '').toLowerCase();
  const getReplacement = (token) =>
    Object.entries(variables).find(
      ([v]) => normalize(token) === normalize(v),
    )?.[1] || '';

  return Object.fromEntries(tokens.map((t) => [t, `${getReplacement(t)}`]));
}

function interpolateInner(pattern, variables, maxLength, lastLength) {
  const interpolated = Object.entries(variables).reduce(
    (memo, [match, replacement]) => memo.replaceAll(match, replacement),
    pattern,
  );

  if (
    !Object.keys(variables).length ||
    interpolated.length <= maxLength ||
    interpolated.length === lastLength
  ) {
    return interpolated;
  }

  return interpolateInner(
    pattern,
    dropWhitespace(variables) || dropNonWhitespace(variables),
    maxLength,
    interpolated.length,
  );
}

function dropWhitespace(variables) {
  const hasWhitespace = Object.entries(variables).find(([, v]) => /\s/.test(v));

  if (hasWhitespace) {
    return {
      ...variables,
      [hasWhitespace[0]]: hasWhitespace[1].replace(/\s/, ''),
    };
  }
}

function dropNonWhitespace(variables) {
  const longestVariable = Object.entries(variables).reduce((memo, current) =>
    memo && memo[1].length > current[1].length ? memo : current,
  );

  return { ...variables, [longestVariable[0]]: shorten(longestVariable[1]) };
}

function shorten(value) {
  const middle = Math.floor(value.length / 2);
  return value.substring(0, middle) + value.substring(middle + 1);
}
